(() => {
  const roots = document.querySelectorAll('[data-offer-bundle]');
  if (!roots.length) return;

  const formatMoney = (cents, locale, currency) => {
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  roots.forEach((root) => {
    let product;
    try {
      product = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
    } catch (_) {
      return;
    }

    const currency = root.dataset.currency || 'USD';
    const locale = root.dataset.locale || undefined;
    const variants = (product.variants || []).filter((variant) => variant.available !== false);
    const cards = [...root.querySelectorAll('[data-offer-card]')];
    const error = root.querySelector('[data-bundle-error]');
    const button = root.querySelector('[data-add-bundle]');
    const addonCheckboxes = [...root.querySelectorAll('[data-addon-checkbox]')];
    const money = (cents) => formatMoney(cents, locale, currency);
    let addonVariantId = null;

    try {
      const addon = JSON.parse(root.querySelector('[data-addon-json]')?.textContent || '{}');
      addonVariantId = (addon.variants || []).find((variant) => variant.available !== false)?.id || null;
    } catch (_) {
      addonVariantId = null;
    }

    const variantLabel = (variant) => {
      const options = (variant.options || []).filter(Boolean);
      return options.length ? options.join(' / ') : (variant.title || product.title || 'Default');
    };

    const fillSelect = (select) => {
      const previous = select.value;
      select.replaceChildren();
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variantLabel(variant);
        select.append(option);
      });
      if (variants.some((variant) => String(variant.id) === previous)) select.value = previous;
      select.disabled = variants.length === 0;
    };

    const refreshCard = (card) => {
      const input = card.querySelector('[data-offer-input]');
      const selects = [...card.querySelectorAll('[data-variant-select]')];
      const freeCount = Number(input?.dataset.free || 0);
      const price = card.querySelector('[data-offer-price]');
      const compare = card.querySelector('[data-offer-compare]');

      selects.forEach(fillSelect);
      const selectedVariants = selects.map((select) => variants.find((variant) => String(variant.id) === select.value)).filter(Boolean);
      const regularTotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
      const sortedPrices = selectedVariants.map((variant) => Number(variant.price || 0)).sort((a, b) => a - b);
      const freeValue = sortedPrices.slice(0, freeCount).reduce((sum, value) => sum + value, 0);
      const offerTotal = regularTotal - freeValue;

      if (price) price.textContent = money(offerTotal);
      if (compare) {
        compare.textContent = money(regularTotal);
        compare.hidden = freeCount < 1 || regularTotal <= offerTotal;
      }
      card.dataset.quantity = String(selects.length);
    };

    const syncAddonCheckboxes = (source) => {
      addonCheckboxes.forEach((checkbox) => { checkbox.checked = source.checked; });
    };

    cards.forEach((card) => {
      card.querySelectorAll('[data-variant-select]').forEach((select) => {
        select.addEventListener('change', () => refreshCard(card));
      });
      card.querySelector('[data-offer-input]')?.addEventListener('change', () => {
        cards.forEach((other) => other.classList.toggle('is-selected', other === card));
        refreshCard(card);
      });
      refreshCard(card);
    });

    addonCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => syncAddonCheckboxes(checkbox));
    });

    button?.addEventListener('click', async () => {
      const selected = cards.find((card) => card.querySelector('[data-offer-input]')?.checked);
      if (!selected) return;

      const ids = [...selected.querySelectorAll('[data-variant-select]')]
        .map((select) => Number(select.value))
        .filter(Number.isFinite);
      if (!ids.length || ids.length !== selected.querySelectorAll('[data-variant-select]').length) {
        error.textContent = 'Please choose an available variant for every item.';
        error.hidden = false;
        return;
      }

      if (addonCheckboxes.some((checkbox) => checkbox.checked) && addonVariantId) ids.push(Number(addonVariantId));
      error.hidden = true;
      button.disabled = true;

      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.href = `${rootPath}cart`;
      } catch (_) {
        error.textContent = 'We could not add this offer. Please try again.';
        error.hidden = false;
        button.disabled = false;
      }
    });
  });
})();